export default __webpack_public_path__ + "static/logo-vert-3942a23cd68d3ef7cacd95b71b0963e4.svg";